import React from "react";
import s from './SaveModal.module.scss';
import { CopyIcon, PdfIcon } from "../../../assets/icon";
import { downloadPdf } from "../../../api";


const SaveModal = ({...props}) => {
	const { link, pdfName } = props;

	console.log(link, pdfName )

	const handleCopy = () => {
		navigator.clipboard.writeText(link)
	}

	const handleDownload = () => {
		downloadPdf(pdfName)
	}

	return (
		<>
			<div className={s.info}>
				<p className={s.header}>
					Summary of boat build
				</p>
				<p className={s.description}>
					You can view all the items of the boat that you have selected by
					following the link below
				</p>
			</div>
			<div className={s.linkBox}>
				<p className={s.link}>
					{link}
				</p>
				<p className={s.copy} onClick={handleCopy}>
					<CopyIcon /> Copy link
				</p>
			</div>
			<div className={s.buttonBox}>
				<button onClick={handleDownload}> <PdfIcon /> Download pdf</button>

			</div>
		</>
	);
}

export default SaveModal;
